//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'product-card-preview-default',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      flowplayer: null,
      isFirstPlay: true,
      isPlaying: false,
    };
  },
  props: {
    element: Object,
    isHovering: {
      type: Boolean,
      default: false,
    },
    // mute: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  computed: {
    posterImageUrl() {
      return _.get(this.element, 'thumbnails.jpg.url') || 'https://static.moele.me/img/placeholders/placeholder-640x360-light.jpg?w=480';
    },
    videoUrl() {
      const videoUrl = _.get(this.element, 'thumbnails.mp4.url') || _.get(this.element, 'previews.mp4.url');

      // just in case, check if is mp4
      if (!videoUrl || videoUrl.lastIndexOf('.mp4') === -1) {
        return null;
      }

      return videoUrl;
    },
    showStaticPreview() {
      return !(isProductType('image', this.mediaType) || isProductType('3d_model', this.mediaType));
    },
    isSearchResultPage() {
      const isSearchRepo = process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
      return isSearchRepo && this.$route.name.indexOf('view-search') > -1;
    },
    muteSetting() {
      // default mute when not in result page
      if (!this.isSearchResultPage) {
        return true;
      }
      const isMuted = this.$store.getters['search/videoPlayerMuted'];
      return isMuted;
    },
  },
  watch: {
    isHovering(state) {
      if (state) {
        setTimeout(() => {
          this.doPlay();
        },
        150); // delay
      } else {
        this.doPause();
      }
    },
  },
  beforeDestroy() {
    if (this.flowplayer !== null) {
      this.flowplayer.mute(false); // need reset the setting before destory, prevent change page still mute
      this.flowplayer.shutdown();
      this.flowplayer = null;
    }
  },
  methods: {
    doPlay() {
      if (!this.isHovering) return false;

      // console.log('onPlay', [this.element.id]);

      if (!this.flowplayer) {
        this.initVideoPlayer(this.element);
        // check again after init
        if (!this.isHovering) return false;
      }

      this.flowplayer.load();
      this.flowplayer.play();
      this.flowplayer.mute(this.muteSetting);

      this.isPlaying = true;
      this.$bus.$emit('product-video-player-load-play', this.element);

      if (this.isFirstPlay) {
        // emit after playing for 1s, to prevent accidental tracking
        setTimeout(() => {
          // check if it's still playing
          if (this.isPlaying) {
            this.$emit('previewed', true);
            this.isFirstPlay = false;
          }
        }, 1000);
      }

      return true;
    },
    doPause() {
      if (!this.flowplayer) return true;

      this.flowplayer.pause();
      this.flowplayer.unload();

      this.isPlaying = false;
      this.$bus.$emit('product-video-player-pause-unload', this.element);

      return true;
    },
    previewImgError(event) {
      event.target.src = 'https://static.moele.me/img/me-thumb-placeholder.180718.png';
    },
    initVideoPlayer(element) {
      // if (!_.get(this.options, 'enablePlayer')) {
      //   return;
      // }

      const videoUrl = this.videoUrl;

      // just in case, check if is mp4
      if (!videoUrl) {
        return;
      }

      const container = document.getElementById(`player-${element.id}`);
      // const $card = $(this.$el);

      this.flowplayer = flowplayer(container, {
        engine: 'html5',
        // key: (['production', 'stage'].indexOf(process.env.NODE_ENV) >= 0) ? process.env.VUE_APP_FLOWPLAYER_KEY : '',
        key: process.env.VUE_APP_FLOWPLAYER_KEY,
        // debug: (['production', 'stage'].indexOf(process.env.NODE_ENV) >= 0) ? false : true,
        // debug: !isProduction,
        debug: false,
        aspectRatio: '16:9',
        preload: 'auto',
        autoplay: true,
        splash: true,
        loop: true,
        muted: this.muteSetting,
        clip: {
          sources: [
            {
              type: 'video/mp4',
              src: videoUrl,
            },
          ],
        },
      });

      // // Add class to adjust the badge-actionable area for Timeline clearance
      // api
      //   .on('resume', () => {
      //     $card.addClass('is-playing has-played');
      //     this.$emit('update:cardPlayStatus', 'playing');

      //     this.$bus.$emit('audio-player-stop');
      //   })
      //   .on('unload', () => {
      //     $card.removeClass('is-playing');
      //     this.$emit('update:cardPlayStatus', 'paused');
      //   });
    },
  },
};
